<div class="row">
    <div class="col-5 col-sm-6 col-md-8 col-lg-9 title"></div>
    <div class="col-7 col-sm-6 col-md-4 col-lg-3">
        <div class="row">
            <a class="col-4 col-sm-3" role="button" (click)="changeLanguage('pl')">
                <img class="img-fluid rounded-circle pointer" src="assets/images/pl.svg" 
                    alt="PL" [ngClass]="{'selected': checkLanguage('pl')}">
            </a>
            <a class="col-4 col-sm-3" role="button" (click)="changeLanguage('en')">
                <img class="img-fluid rounded-circle pointer" src="assets/images/gb.svg" 
                    alt="EN" [ngClass]="{'selected': checkLanguage('en')}">
            </a>
            <span class="col-6 d-none d-sm-inline-block mr-auto ml-md-3 my-2 my-md-0 mw-100">
                <img class="img-fluid" src="assets/images/QCloud.png" alt="QCloud">
            </span>
            <span class="col-4 nav-item d-sm-none mr-auto ml-md-3 my-md-0 mw-100">
                <img class="img-fluid" src="assets/images/qcloud-logo.png" alt="QCloud">                
            </span>
        </div>
    </div>
</div>
